//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { SamplingCampaignRequestCurrency } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';

export const DEFAULT_CURRENCY = 'USD';

export const CAMPAIGN_REQUEST_CURRENCIES: {
  value: SamplingCampaignRequestCurrency;
  label: string;
  symbol: string;
}[] = [
  {
    value: 'USD',
    label: 'USD ($)',
    symbol: '$',
  },
  {
    value: 'EUR',
    label: 'EUR (€)',
    symbol: '€',
  },
  {
    value: 'CAD',
    label: 'CAD ($)',
    symbol: '$',
  },
  {
    value: 'GBP',
    label: 'GBP (£)',
    symbol: '£',
  },
  {
    value: 'AUD',
    label: 'AUD ($)',
    symbol: '$',
  },
  {
    value: 'CHF',
    label: 'CHF (CHF)',
    symbol: 'CHF',
  },
  {
    value: 'CZK',
    label: 'CZK (Kč)',
    symbol: 'Kč',
  },
  {
    value: 'DKK',
    label: 'DKK (kr)',
    symbol: 'kr',
  },
  {
    value: 'HUF',
    label: 'HUF (Ft)',
    symbol: 'Ft',
  },
  {
    value: 'NOK',
    label: 'NOK (kr)',
    symbol: 'kr',
  },
  {
    value: 'PLN',
    label: 'PLN (zł)',
    symbol: 'zł',
  },
  {
    value: 'SEK',
    label: 'SEK (kr)',
    symbol: 'kr',
  },
];
